import Actions from "../action";
const initialState = {
  schedules: [],
  loading: false,
  updating: false,
  error: null,
  successMessage: null, 
  updateResponse: null
};

const emailScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.UPDATE_EMAIL_SCHEDULE_REQUEST:
      return {
        ...state,
        updating: true, 
        error: null,
        successMessage: null
      };

    case Actions.UPDATE_EMAIL_SCHEDULE_SUCCESS:
      return {
        ...state,
        updating: false, 
        updateResponse: action.data,
        successMessage: action.data?.message || 'Schedule updated successfully',
        error: null
      };

    case Actions.UPDATE_EMAIL_SCHEDULE_FAILURE:
      return {
        ...state,
        updating: false, 
        error: action.data,
        successMessage: null
      };

    case Actions.LIST_EMAIL_SCHEDULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case Actions.LIST_EMAIL_SCHEDULES_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: action.data,
        error: null
      };

    case Actions.LIST_EMAIL_SCHEDULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.data,
        schedules: []
      };

    case Actions.CLEAR_EMAIL_SCHEDULE_ERRORS:
      return {
        ...state,
        error: null,
        successMessage: null,
        updateResponse: null
      };

    default:
      return state;
  }
};

// Selectors
export const getEmailSchedulerListSelector = (state) => 
  state.EMAIL_SCHEDULER?.schedules || [];

export const getEmailSchedulerLoadingSelector = (state) => 
  state.EMAIL_SCHEDULER?.loading || false;

export const getEmailSchedulerErrorSelector = (state) => 
  state.EMAIL_SCHEDULER?.error || null;

export const getEmailSchedulerSuccessMessageSelector = (state) => 
  state.EMAIL_SCHEDULER?.successMessage || null;

export const getEmailSchedulerUpdateResponseSelector = (state) => 
  state.EMAIL_SCHEDULER?.updateResponse || null;

export const getEmailSchedulerUpdatingSelector = (state) => 
  state.EMAIL_SCHEDULER?.updating || false;

export default emailScheduleReducer;